import React, { useMemo } from 'react';

import DayJs from 'utils/Dayjs';
import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Avatar from 'components/Misc/Avatar';
import { Mark, Title } from 'components/Misc/Typography';
import { Button, Checkbox } from 'components/Misc/Form';

import { EXAM_STUDENT_STATES } from 'utils/Constants';

// import { useCourseStudentStore } from 'store/course/useCourseStudentStore';

const Student = ({ student }) => {
	// Find latest take
	const latest = useMemo(() => {
		return student.takes?.[0] || {};
	}, [student]);

	// Find status info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === latest.state), [latest]);

	return (
		<div className="py-2 px-4 flex items-center space-x-2 border-t border-neutral-100 first:border-t-0">
			{/* Student's avatar */}
			<Avatar
				small
				alt={student.fullName}
				src={student.avatar}
			/>
			
			{/* Student's name */}
			<Title
				title={student.fullName}
				className="flex-1"
			/>

			{/* Course's startDate */}
			<div className="text-sm text-neutral-600 w-28">
				{`${DayJs(student.courserel.startDate).format('D. MMM, YYYY')}`}
			</div>

			{/* Course's endDate */}
			<div className="text-sm text-neutral-600 w-28">
				{`${DayJs(student.courserel.endDate).format('D. MMM, YYYY')}`}
			</div>

			{/* Take's state */}
			<div className="w-24">
				<Show if={state}>
					<Pill name={state?.text} theme={state?.theme} />
				</Show>
			</div>

			{/* Show mark in course */}
			<div className="w-7">
				<Show if={latest?.id && latest?.mark}>
					<Mark mark={latest?.mark} />
				</Show>
			</div>

			{/* Redirect to student */}
			<Button
				small
				square
				icon="link"
				to={`/users/${student.id}`}
			/>
		</div>
	);
};

export default Student;